export default function SimpleInput({
  title,
  required = false,
  setInputValue,
  inputValue,
  placeholder = "",
  valueType = "text",
  readOnly = false,
}) {
  return (
    <div className="w-full mb-4">
      {title ? (
        <div className="w-full mb-2 flex justify-start items-center text-medium font-IRANSansBold">
          {title}
          {required ? <span className="text-scabRed mr-1">*</span> : null}
        </div>
      ) : null}
      <input
        type={valueType}
        readOnly={readOnly}
        className={`w-full h-[44px] rounded-[12px] border border-scabLightGray px-3 focus:border-scabLightGray focus:outline-none font-[600] placeholder:font-IRANSanslight placeholder:text-scabLightGray ${
          readOnly ? "bg-scabPageBg text-scabBtnGray" : "bg-scabWhite"
        }`}
        onChange={(e) => setInputValue && setInputValue(e.target.value)}
        value={inputValue}
        placeholder={placeholder}
      />
    </div>
  );
}
